const API_URL = process.env.API_URL;

export const PATHS = {
    assignments: {
        getAssignment: (id) => {
            return `${process.env.API_URL}rest/assignment/admin/${id}`;
        },
        getAssignments: {
            filtered: (filterBy, sortBy, sortDirection, pageNumber, pageSize, userId) => {
                if(filterBy === '') {
                    return `${process.env.API_URL}rest/assignment/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=state!cancelled&filter=archived!true&filter=deleted=false`;
                } else if(filterBy === 'live') {
                    return `${process.env.API_URL}rest/assignment/admin/search/live?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=state!cancelled&filter=archived!true&filter=deleted=false`;
                } else if(filterBy === 'overdue' || filterBy === 'complete') {
                    return `${process.env.API_URL}rest/assignment/admin/search/status/${filterBy}?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=state!cancelled&filter=archived!true&filter=deleted=false`;
                } else if(filterBy === 'creator') {
                    return `${process.env.API_URL}rest/assignment/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=creator=${userId}&filter=state!cancelled&filter=archived!true&filter=deleted=false`;
                } else if(filterBy === 'recurring') {
                    return `${process.env.API_URL}rest/assignment/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=recurrance!none&filter=state!cancelled&filter=archived!true&filter=deleted=false`;
                } else if(filterBy === 'unpublished' || filterBy === 'cancelled') {
                    return `${process.env.API_URL}rest/assignment/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=state=${filterBy}${filterBy !== 'cancelled' ? '&filter=state!cancelled' : ''}&filter=archived!true&filter=deleted=false`;
                } else if(filterBy === 'archived') {
                    return `${process.env.API_URL}rest/assignment/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=state!cancelled&filter=archived=true&filter=deleted=false`;
                }
            },
            search: (searchTerm, pageNumber, pageSize) => {
                return `${process.env.API_URL}rest/assignment/admin/?page=${pageNumber}&pageSize=${pageSize}&order=modified&filter=name~${searchTerm}&filter=deleted=false`;
            },
            sorted: (sortBy, sortDirection, pageNumber, pageSize) => {
                if(sortBy === 'status') {
                    return `${process.env.API_URL}rest/assignment/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&transient-order=status&filter=state!cancelled&filter=archived!true&filter=deleted=false`;
                } else {
                    return `${process.env.API_URL}rest/assignment/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=state!cancelled&filter=archived!true&filter=deleted=false`;
                }
            }
        },
        getAssignmentMultiple: (idArray) => `${API_URL}rest/assignment/admin/multi/${idArray}`,
        postAssignment: () => {
            return `${process.env.API_URL}rest/assignment`;
        },
        putAssignment: (id) => {
            return `${process.env.API_URL}rest/assignment/${id}`;
        }
    },
    auth: {
        adminTest: () => {
            return `${process.env.API_URL}rest/user/role`
        },
        authTest: () => {
            return `${process.env.API_URL}rest/user/name`
        },
        forgotPassword: () => {
            return `${API_URL}forgot`;
        },
        login: () => {
            return `${process.env.API_URL}j_security_check`;
        },
        logout: () => {
            return `${process.env.API_URL}signout`;
        },
        myAdmin: () => {
            return `${process.env.API_URL}rest/user/myAdmin`;
        },
        signup: () => {
            return `${process.env.API_URL}signup`;
        },
    },
    content: {
        getContent: {
            filtered: (filterBy, sortBy, sortDirection, pageNumber, pageSize, userId) => {
                if(filterBy === '') {
                    return `${process.env.API_URL}rest/content/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=deleted=false`;
                } else if(['assessment', 'checklist', 'html', 'hotspot', 'survey'].indexOf(filterBy) !== -1) {
                    return `${process.env.API_URL}rest/content/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=type=${filterBy}&filter=deleted=false`;
                } else if(['elearning', 'web'].indexOf(filterBy) !== -1) {
                    return `${process.env.API_URL}rest/content/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=type=web&filter=marketingType${filterBy === 'web' ? '!elearning' : '=elearning'}&filter=deleted=false`;
                } else if(filterBy === 'web') {
                    return `${process.env.API_URL}rest/content/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=type=${filterBy}&marketingType!elearning&filter=deleted=false`;
                } else if(filterBy === 'creator') {
                    return `${process.env.API_URL}rest/content/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=creator=${userId}&filter=deleted=false`;
                } else if(filterBy === 'isInLibrary') {
                    return `${process.env.API_URL}rest/content/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=${filterBy}=true&filter=deleted=false`;
                } else {
                    return `${process.env.API_URL}rest/content/search/fileType/${filterBy}?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=deleted=false`;
                }
            },
            search: (searchTerm, pageNumber, pageSize) => {
                return `${process.env.API_URL}rest/content/admin/?page=${pageNumber}&pageSize=${pageSize}&order=modified&filter=name~${searchTerm}&filter=deleted=false`;
            },
            sorted: (sortBy, sortDirection, pageNumber, pageSize) => {
                return `${process.env.API_URL}rest/content/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=deleted=false`;
            }
        },
        postContent: () => {
            return `${process.env.API_URL}rest/content`;
        },
        putContent: (id) => {
            return `${process.env.API_URL}rest/content/${id}`;
        }
    },
    groups: {
        getGroups: {
            filtered: (filterBy, sortBy, sortDirection, pageNumber, pageSize, userId) => {
                return `${process.env.API_URL}rest/department/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}${filterBy === 'creator' ? '&filter=creator=' + userId : ''}&filter=deleted=false`;
            },
            search: (searchTerm, pageNumber, pageSize) => {
                return `${process.env.API_URL}rest/department/admin/search/name/${searchTerm}?page=${pageNumber}&pageSize=${pageSize}&order=modified&filter=deleted=false`;
            },
            sorted: (sortBy, sortDirection, pageNumber, pageSize) => {
                return `${process.env.API_URL}rest/department/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=deleted=false`;
            }
        },
        postGroup: () => {
            return `${process.env.API_URL}rest/department`;
        },
        putGroup: (id) => {
            return `${process.env.API_URL}rest/department/${id}`;
        }
    },
    pinpoints: {
        getPinpoints: {
            filtered: (filterBy, sortBy, sortDirection, pageNumber, pageSize, userId) => {
                if(filterBy === 'creator') {
                    return `${process.env.API_URL}rest/beacon/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=creator=${userId}&filter=deleted=false`;
                } else {
                    return `${process.env.API_URL}rest/beacon/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=type=${filterBy}&filter=deleted=false`;
                }
            },
            search: (searchTerm, pageNumber, pageSize) => {
                return `${process.env.API_URL}rest/beacon/admin/?page=${pageNumber}&pageSize=${pageSize}&order=modified&filter=name~${searchTerm}&filter=deleted=false`;
            },
            sorted: (sortBy, sortDirection, pageNumber, pageSize) => {
                return `${process.env.API_URL}rest/beacon/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=deleted=false`;
            }
        },
        postPinpoint: () => {
            return `${process.env.API_URL}rest/beacon`;
        },
        putPinpoint: (id) => {
            return `${process.env.API_URL}rest/beacon/${id}`;
        }
    },
    reports : {
        getReports: () => {
            return `${process.env.API_URL}rest/reports`;
        }
    },
    users: {
        getUser: {
            byID: (id, getAssignments) => {
                return `${process.env.API_URL}rest/user/${id}?assignments=${getAssignments === false ? 'false' : 'true'}`;
            },
            loggedInUserID: () => {
                return `${process.env.API_URL}rest/user/id`;
            }
        },
        getUsers: {
            filtered: (filterBy, sortBy, sortDirection, pageNumber, pageSize, userId) => {
                if(filterBy === 'admins') {
                    return `${process.env.API_URL}rest/user/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=role!inbox_only&filter=role!search_inbox&filter=role!creator_inbox&filter=role!creator_search_inbox&filter=deleted=false`;
                } else if(filterBy === 'employees') {
                    return `${process.env.API_URL}rest/user/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=role!admin&filter=role!creator_admin&filter=deleted=false`;
                } else {
                    return `${process.env.API_URL}rest/user/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}${filterBy === 'creator' ? '&filter=creator=' + userId : ''}&filter=deleted=false`;
                }
            },
            search: (searchTerm, pageNumber, pageSize, isCreatorAdmin) => {
                return `${process.env.API_URL}rest/user/admin/search/fullName/${searchTerm}?page=${pageNumber}&pageSize=${pageSize}&order=modified&filter=deleted=false${isCreatorAdmin === true ? '&filter=role=inbox_only&filter=role=creator_inbox' : ''}`;
            },
            sorted: (sortBy, sortDirection, pageNumber, pageSize, isCreatorAdmin) => {
                return `${process.env.API_URL}rest/user/admin?reverse=${sortDirection}&page=${pageNumber}&pageSize=${pageSize}&order=${sortBy}&filter=deleted=false${isCreatorAdmin === true ? '&filter=role=inbox_only&filter=role=creator_inbox' : ''}`;
            }
        },
        importUsers: (id, test) => {
            return `${API_URL}rest/user/import/${id}?test=${test}`;
        },
        postUser: () => {
            return `${process.env.API_URL}rest/user`;
        },
        putUser: (id) => {
            return `${process.env.API_URL}rest/user/${id}`;
        }
    },
    upload: {
        file: () => {
            return `${process.env.API_URL}upload?destination=upload`;
        },
        import: () => {
            return `${process.env.API_URL}upload?destination=import`;
        },
        thumbnail: () => {
            return `${process.env.API_URL}upload?destination=thumbnail`;
        }
    }
};



// WEBPACK FOOTER //
// ./src/utils/paths.js